import { InjectionToken, Provider } from '@angular/core';

export const TOOL_LIBRARY_BASE_API_URL = new InjectionToken<string>('tool-library-base-api-url');

export function provideToolLibraryBaseApiUrl(url: string): Provider {
  return { provide: TOOL_LIBRARY_BASE_API_URL, useValue: url };
}
